/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;justify-content:center}.mat-card[_ngcontent-%COMP%]{text-align:center;max-width:600px;line-height:1.4em}.mat-card[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:128px;height:128px;width:128px;color:#ef6c00}"];
export { styles as styles };
